<template>
  <div class="account-type-btn" @click="$emit('select', account)">
    <div class="status-flags" >
      <i class="fa fa-pause-circle" v-if="account.badge.status.isOnHold" style="color: red;" title="On Hold"></i>
      <i class="fa fa-star" v-if="account.badge.status.isVIP" style="background:gold;color: white;border-radius:50%;padding:.25em;" title="VIP"></i>
      <i class="fa fa-child" v-if="account.badge.status.isMinor" style="color: orange;" title="Minor"></i>
      <i class="fa fa-cloud" v-if="account.badge.status.isOffSite" style="color: red;" title="Off Site"></i>
      <i class="fa fa-plane-departure" v-if="account.badge.status.isOnLeave" style="color: firebrick;" title="On Leave"></i>
      <i class="fa fa-user-plus" v-if="account.badge.status.isParent" style="color: #28a745;" title="Parent"></i>
      <i class="fa fa-user-secret" v-if="account.badge.status.isGuest" style="color: green;" title="Guest"></i>
    </div>
    <div class="account-type-content">
      <span v-if="account.badge && account.badge.pictureUrl">
        <img :src="account.badge.pictureUrl" class="account-type-avatar-img" />
      </span>
      <span v-else>
        <i class="fa fa-user account-type-icon"></i>
      </span>
      <div>
      <!-- {{ account.badge.status }} -->
        <div class="account-type-label">{{ account.badge ? account.badge.alias : '' }}</div>
        <div class="account-type-title">{{ account.accountTitle }}
          <!-- <i class="fa fa-user" v-if="account.badge.status.isOnHold"></i>
          <i class="fa fa-user" v-if="account.badge.status.isVIP"></i>
          <i class="fa fa-user" v-if="account.badge.status.isMinor"></i>
          <i class="fa fa-user" v-if="account.badge.status.isOffSite"></i>
          <i class="fa fa-user" v-if="account.badge.status.isOnLeave"></i>
          <i class="fa fa-user" v-if="account.badge.status.isParent"></i>
          <i class="fa fa-user" v-if="account.badge.status.isGuest"></i> -->
        </div>
        
      </div>
    </div>
    <div class="account-type-details">
      <div v-if="account.roomNumber" class="account-type-room">Room: {{ account.roomNumber }}</div>
      <div class="account-type-number">{{ account.accountNumber }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountTile',
  props: {
    account: { type: Object, required: true }
  }
}
</script>

<style scoped>
.status-flags {
  position:absolute; 
  right:20px;
  font-size:1.5em;
  .fa {
    padding-right:.25em;
  }
}

.account-type-btn {
  width: 100%;
  min-width: 200px;
  min-height: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 1em;
  font-weight: 500;
  border-radius: 1em;
  box-shadow: 0 1px 4px rgba(101,157,189,0.08);
  border: 1.5px solid #dbeaf3;
  background: #f7fafc;
  color: #193628;
  margin-bottom: 0.75em;
  transition: box-shadow 0.2s, border-color 0.2s, background 0.2s;
  cursor: pointer;
  padding: 0.75em 1.25em;
}
.account-type-btn:hover, .account-type-btn:focus {
  background: #eaf3f8;
  border-color: #659DBD;
  box-shadow: 0 2px 8px rgba(101,157,189,0.13);
}
.account-type-content {
  display: flex;
  align-items: center;
  gap: 0.75em;
  width: 100%;
  justify-content: flex-start;
}
.account-type-icon {
  font-size: 1.7em;
  color: #659DBD;
}
.account-type-avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e0e0e0;
  background: #f7f7f7;
}
.account-type-label {
  /* position:relative;
  top:-.5em; */
  font-weight: 700;
  font-size: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.account-type-title {
  font-size: 0.8em;
  color: #417ba0;
}
.account-type-details {
  margin-left:45px;
  display: block;
  margin-top: 0.2em;
  border-top:1px solid lightgray;
}
.account-type-room {
  font-size: 0.8em;
  color: #888;
  margin-right: 0.5em;
}
.account-type-number {
  font-size: 0.8em;
  color: #aaa;
}
</style>
